import React from 'react';
import styled from 'styled-components';
import { Card } from 'react-bootstrap';
import { colors, radius, shadow, spacing, typography } from '../tokens';

// AuthCard — khung trung tâm cho login / change-password / OTP / form
// xác nhận. Sử dụng react-bootstrap Card; styled-components chỉ thêm
// padding + shadow + radius theo tokens. `maxWidth` cho phép mở rộng
// (vd form nhiều field thì truyền 720). Default 480 phù hợp form
// đăng nhập / đổi mật khẩu.
function AuthCard({ title, subtitle, children, footer, maxWidth = 480 }) {
  return (
    <Wrapper $maxWidth={maxWidth}>
      <StyledCard>
        <Card.Body className='p-4 p-md-5'>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          <div>{children}</div>
          {footer && <Footer>{footer}</Footer>}
        </Card.Body>
      </StyledCard>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  max-width: ${(p) => p.$maxWidth}px;
  margin: 0 auto;
`;

const StyledCard = styled(Card)`
  border: 1px solid ${colors.border};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.md};
  background: ${colors.surface};
`;

const Title = styled.h3`
  font-size: ${typography.size.h3};
  font-weight: ${typography.weight.bold};
  color: ${colors.gray900};
  margin-bottom: ${spacing[1]};

  @media (max-width: 640px) {
    font-size: ${typography.size.xl};
  }
`;

const Subtitle = styled.p`
  font-size: ${typography.size.sm};
  color: ${colors.gray500};
  line-height: ${typography.leading.relaxed};
  margin-bottom: ${spacing[5]};

  @media (max-width: 640px) {
    margin-bottom: ${spacing[4]};
  }
`;

const Footer = styled.div`
  margin-top: ${spacing[5]};
  padding-top: ${spacing[4]};
  border-top: 1px solid ${colors.border};
  font-size: ${typography.size.sm};
  color: ${colors.gray500};
  text-align: center;
`;

export default AuthCard;
